import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useLayoutHeaderStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: 'white'
    },

    button: {
      marginLeft: 'auto'
    },

    logo: {
      width: 136,
      height: 40
    },

    title: {
      flexGrow: 1,
      fontWeight: 600,
      display: 'none',

      [theme.breakpoints.up('md')]: {
        display: 'block'
      }
    },

    rect: {
      height: 4,
      width: 4,
      backgroundColor: 'currentColor',
      display: 'none',
      borderRadius: '50%',
      margin: '0 8px 0 5px',

      [theme.breakpoints.up('md')]: {
        display: 'block'
      }
    }
  })
)
